(() => {
  'use strict';

  const config = window.FaccoLocaleNavigation || {};
  const rawRoot = typeof config.rootUrl === 'string' ? config.rootUrl : '/';
  const rootUrl = rawRoot === '/' ? '/' : `/${rawRoot.replace(/^\/+|\/+$/g, '')}`;

  // The Italian storefront has no language prefix, so no URL rewriting is needed.
  if (rootUrl === '/') return;

  const explicitLocalePath = /^\/(?:it|en|es)(?:-[a-z0-9-]+)?(?:\/|$)/i;
  const excludedPath = /^\/(?:admin|checkouts?|challenge|password|services|cdn|wpm)(?:\/|$)/i;
  const ignoredProtocols = /^(?:mailto:|tel:|sms:|javascript:|data:)/i;

  function isLanguageControl(anchor) {
    return Boolean(
      anchor.closest('.fac-language-switcher') ||
      anchor.closest('form[action*="localization"]') ||
      anchor.hasAttribute('hreflang') ||
      anchor.hasAttribute('data-no-localize') ||
      anchor.getAttribute('rel') === 'alternate'
    );
  }

  function localizedHref(anchor) {
    const href = anchor.getAttribute('href');
    if (!href || href === '#' || href.startsWith('#') || ignoredProtocols.test(href)) return null;
    if (isLanguageControl(anchor)) return null;

    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch (_error) {
      return null;
    }

    if (url.origin !== window.location.origin) return null;
    if (excludedPath.test(url.pathname)) return null;
    if (url.pathname === rootUrl || url.pathname.startsWith(`${rootUrl}/`)) return null;

    // Do not overwrite links that deliberately point to another language/market.
    if (explicitLocalePath.test(url.pathname)) return null;

    const path = url.pathname === '/' ? '' : url.pathname;
    url.pathname = `${rootUrl}${path}` || rootUrl;
    return `${url.pathname}${url.search}${url.hash}`;
  }

  function localizeAnchor(anchor) {
    if (!(anchor instanceof HTMLAnchorElement)) return;
    const nextHref = localizedHref(anchor);
    if (nextHref) anchor.setAttribute('href', nextHref);
  }

  function localizeTree(root) {
    if (!root) return;
    if (root instanceof HTMLAnchorElement) localizeAnchor(root);
    if (root.querySelectorAll) root.querySelectorAll('a[href]').forEach(localizeAnchor);
  }

  function start() {
    localizeTree(document);

    // Sections, recommendations and drawers can be rendered after page load.
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) localizeTree(node);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    // Final safety check immediately before navigation.
    document.addEventListener('click', (event) => {
      const anchor = event.target.closest && event.target.closest('a[href]');
      if (anchor) localizeAnchor(anchor);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
